"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4047],{

/***/ 74047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ad": function() { return /* reexport */ ProductAlternativesCard; },
  "Il": function() { return /* reexport */ src_ProductCard; },
  "Bl": function() { return /* reexport */ fragments_ProductCardFieldsFragment; },
  "zi": function() { return /* reexport */ ProductDeploymentCard; },
  "o": function() { return /* reexport */ ProductDetailsCard; },
  "en": function() { return /* reexport */ fragments_ProductFieldsFragment; },
  "Li": function() { return /* reexport */ ProductGallery; },
  "mW": function() { return /* reexport */ ProductGovernments; },
  "cN": function() { return /* reexport */ ProductHeader; },
  "dw": function() { return /* reexport */ ProductIntegrationsCard; },
  "nu": function() { return /* reexport */ ProductNewsworthy; },
  "F5": function() { return /* reexport */ ProductSharing; },
  "XF": function() { return /* reexport */ ProductSiblingsCard; },
  "JY": function() { return /* reexport */ ProductSolutionsCard; },
  "wN": function() { return /* reexport */ ProductVendorCard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/box/Box.tsx + 3 modules
var Box = __webpack_require__(49019);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/icons.tsx





var ProductDetailsCardIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardIcon */._K, {
        viewBox: "0 0 24 24",
        width: "24px",
        height: "24px",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.845 24h6.31A8.845 8.845 0 0024 15.155v-6.31A8.845 8.845 0 0015.155 0h-6.31A8.845 8.845 0 000 8.845v6.31A8.845 8.845 0 008.845 24zM3.981 3.98a6.88 6.88 0 014.864-2.014h6.31a6.88 6.88 0 016.88 6.88v6.309a6.88 6.88 0 01-6.88 6.88h-6.31a6.88 6.88 0 01-6.88-6.88v-6.31a6.88 6.88 0 012.016-4.864zm7.582 3.751c.15.062.31.093.472.092a1.26 1.26 0 00.897-.359 1.192 1.192 0 00.335-.629c.007-.08.007-.16 0-.24a1.251 1.251 0 00-.36-.87 1.278 1.278 0 00-1.745 0c-.056.058-.107.12-.152.187-.09.133-.152.284-.183.442a1.221 1.221 0 00.735 1.377zm1.457 2.304v6.388h.591a.987.987 0 01.986.983.981.981 0 01-.986.982h-3.154a.987.987 0 01-.985-.982.981.981 0 01.985-.983h.592v-5.406h-.493a.987.987 0 01-.985-.982.981.981 0 01.985-.983h1.479a.987.987 0 01.986.983z",
            fill: "#086BE5"
        })
    });
};
var DeploymentCardIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardIcon */._K, {
        viewBox: "0 0 24 24",
        width: "24px",
        height: "24px",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M8.692 18.925a3.124 3.124 0 01-3.067 2.512h-2.5a.624.624 0 01-.624-.623V18.32a3.12 3.12 0 012.519-3.058l.014-.427c.025-.723.1-1.432.22-2.124H.627a.623.623 0 01-.58-.855l2.5-6.233a.625.625 0 01.58-.391H8.75c.032 0 .063.002.094.007A15.397 15.397 0 0120.964.01c.764.026 1.524.108 2.275.247a.624.624 0 01.5.5c1.026 5.523-1.049 10.902-4.995 14.357a.62.62 0 01.006.09v5.61a.623.623 0 01-.393.578l-6.25 2.494a.625.625 0 01-.857-.58V18.69a15.44 15.44 0 01-2.13.221l-.428.015zm-1.207-.362l-2.103-2.096a1.872 1.872 0 00-1.631 1.854v1.87h1.874c.954 0 1.74-.71 1.86-1.628zm5.015-.146v3.97l5-1.995v-4.298a15.335 15.335 0 01-5 2.323zm-6.974-6.952A15.262 15.262 0 017.861 6.48H3.55l-2 4.986h3.977zm2.85 6.224l.701-.024c.702-.025 1.4-.1 2.09-.228 7.546-1.394 12.578-8.515 11.416-16.027a14.198 14.198 0 00-1.662-.155C13.107.986 6.553 7.085 6.284 14.88l-.025.7 2.116 2.11zM15 12.712a3.745 3.745 0 01-3.75-3.74A3.745 3.745 0 0115 5.232a3.745 3.745 0 013.75 3.74 3.745 3.745 0 01-3.75 3.74zm0-1.247c1.381 0 2.5-1.116 2.5-2.493A2.497 2.497 0 0015 6.48c-1.38 0-2.5 1.116-2.5 2.493a2.496 2.496 0 002.5 2.493z",
            fill: "#086BE5"
        })
    });
};
var ResourcesCardIcon = function() {
    return /*#__PURE__*/ _jsxs(CardIcon, {
        viewBox: "0 0 24 24",
        width: "24px",
        height: "24px",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M23.67 9.085a.595.595 0 00-.483-.246h-.023c-.04-.555-.424-1.115-1.153-1.666a4.381 4.381 0 00-1.406-.709c1.619-1.462 1.28-2.45-.518-4.603C19.414 1.054 18.87.688 18.312.71c-.595.01-.936.45-1.14.713a.278.278 0 00-.009.012c-.116-.09-.21-.205-.352-.377a6.368 6.368 0 00-.761-.805c-.225-.2-.549-.28-.958-.243-1.698.153-5.829 2.53-7.016 4.037-.586.745-1.127.561-2.56-.41-.257-.174-.524-.355-.786-.508-.29-.169-.625-.19-.942-.058-1.27.53-2.37 4.125-2.815 5.77H.595a.595.595 0 00-.564.78l2.432 7.277A3.92 3.92 0 00.837 20.07a3.94 3.94 0 007.833.593h6.44a3.94 3.94 0 007.833-.592 3.92 3.92 0 00-1.625-3.174L23.75 9.62a.59.59 0 00-.08-.535zM4.195 4.191c.207.125.424.272.652.426 1.114.755 2.797 1.895 4.163.162 1.194-1.515 5.462-3.707 6.3-3.596.26.236.423.434.58.626.255.309.495.6.98.825.638.294 1.06-.253 1.242-.487.064-.08.18-.232.221-.252.003 0 .247.014.84.725 1.698 2.035 1.524 2.188.553 3.036-.454.398-.847.74-.726 1.225.11.439.527.537.862.616.372.087.88.206 1.43.622.472.355.62.598.668.72H2.207c.65-2.306 1.514-4.34 1.989-4.648zm.583 18.623a2.751 2.751 0 01-2.753-2.744 2.751 2.751 0 012.753-2.744A2.751 2.751 0 017.53 20.07a2.751 2.751 0 01-2.752 2.744zm14.224 0a2.751 2.751 0 01-2.752-2.744 2.751 2.751 0 012.752-2.744 2.751 2.751 0 012.752 2.744 2.751 2.751 0 01-2.752 2.744zm1.247-6.47a3.932 3.932 0 00-1.247-.204 3.94 3.94 0 00-3.892 3.337H8.67a3.94 3.94 0 00-3.891-3.337 3.93 3.93 0 00-1.247.204l-2.113-6.32h20.943l-2.112 6.32z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.955 15.21a.594.594 0 00.594-.592v-3.211a.593.593 0 00-1.189 0v3.21c0 .328.266.594.595.594zM18.827 15.21a.594.594 0 00.594-.592v-3.211a.594.594 0 00-1.189 0v3.21c0 .328.267.594.595.594zM16.052 15.21a.594.594 0 00.595-.592v-3.211a.594.594 0 00-1.19 0v3.21c0 .328.267.594.595.594zM13.278 15.21a.594.594 0 00.595-.592v-3.211a.594.594 0 00-1.19 0v3.21c0 .328.267.594.595.594zM10.504 15.21a.594.594 0 00.594-.592v-3.211a.593.593 0 00-1.189 0v3.21c0 .328.266.594.595.594zM7.73 15.21a.594.594 0 00.594-.592v-3.211a.593.593 0 00-1.19 0v3.21c0 .328.266.594.595.594z",
                fill: "#086BE5"
            })
        ]
    });
};
var SimilarProductsCardIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardIcon */._K, {
        viewBox: "0 0 24 24",
        width: "24px",
        height: "24px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#prefix__clip0)",
                stroke: "#086BE5",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M.5 5.5h11v13.285a11.18 11.18 0 01-1.44.783c-1.038.47-2.466.932-4.06.932-1.594 0-3.022-.462-4.06-.931a11.176 11.176 0 01-1.44-.784V5.5z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M11.5 5c0 .057-.034.191-.281.386-.241.19-.62.383-1.134.554-1.023.34-2.467.56-4.085.56-1.618 0-3.062-.22-4.085-.56-.513-.171-.893-.364-1.134-.554C.534 5.19.5 5.057.5 5c0-.057.034-.191.281-.386.241-.19.62-.383 1.134-.554C2.938 3.72 4.382 3.5 6 3.5c1.618 0 3.062.22 4.085.56.513.171.893.364 1.134.554.247.195.281.329.281.386z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M2.682 11.773h6.272M2.682 14.682h6.272"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M14.5 9.5h9v9.756l-.127.072c-.235.129-.578.303-1.007.477-.86.35-2.044.695-3.366.695s-2.506-.344-3.366-.695a9.645 9.645 0 01-1.134-.549V9.5z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M23.5 9c0 .095-.046.235-.236.415-.192.182-.496.368-.914.535-.832.333-2.016.55-3.35.55-1.333 0-2.517-.217-3.35-.55-.417-.167-.722-.353-.913-.535-.191-.18-.237-.32-.237-.415 0-.094.046-.235.237-.415.191-.181.496-.368.913-.535.833-.333 2.017-.55 3.35-.55 1.334 0 2.518.217 3.35.55.418.167.722.354.914.535.19.18.236.32.236.415z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M16.5 16.5h5M16.5 13.5h5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "prefix__clip0",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M0 0h24v24H0V0z",
                        fill: "#fff"
                    })
                })
            })
        ]
    });
};
var AddToStackIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12,
                r: 11.5,
                fill: "#fff",
                stroke: "#28D094"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13.381 13.405l4.18.035a1.393 1.393 0 10.023-2.786l-4.18-.035.036-4.18a1.393 1.393 0 10-2.786-.023l-.035 4.18-4.18-.036a1.393 1.393 0 00-.023 2.786l4.18.035-.036 4.18a1.393 1.393 0 002.786.023l.035-4.18z",
                fill: "#28D094"
            })
        ]
    });
};
var AddedToStackIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12,
                r: 11.5,
                fill: "#fff",
                stroke: "#28D094"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M13.381 13.405l4.18.035a1.393 1.393 0 10.023-2.786l-4.18-.035.036-4.18a1.393 1.393 0 10-2.786-.023l-.035 4.18-4.18-.036a1.393 1.393 0 00-.023 2.786l4.18.035-.036 4.18a1.393 1.393 0 002.786.023l.035-4.18z",
                fill: "#28D094"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                fill: "#21AD7B"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.376 6.192c.614.375.808 1.178.432 1.793l-5.739 9.39a1.304 1.304 0 01-2.213.02l-3.652-5.738a1.304 1.304 0 112.2-1.4l2.53 3.974 4.649-7.607a1.304 1.304 0 011.793-.432z",
                fill: "#fff"
            })
        ]
    });
};
var AppStore = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 115,
        height: 40,
        viewBox: "0 0 135 40"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#A6A6A6",
                d: "M130.197 40H4.729A4.74 4.74 0 0 1 0 35.267V4.726A4.733 4.733 0 0 1 4.729 0h125.468C132.803 0 135 2.12 135 4.726v30.541c0 2.605-2.197 4.733-4.803 4.733z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: "#FFF",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154zM26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: "#FFF",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.41l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549L48.63 22.48c-.119-.355-.342-1.191-.671-2.507h-.04a96.75 96.75 0 0 1-.632 2.507l-1.105 3.475h3.573zM64.662 26.588c0 1.632-.441 2.922-1.323 3.869-.79.843-1.771 1.264-2.942 1.264-1.264 0-2.172-.454-2.725-1.362h-.04v5.055H55.5V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.132 0 2.077.447 2.833 1.342.758.896 1.136 2.074 1.136 3.535zm-2.172.078c0-.934-.21-1.704-.632-2.31-.461-.632-1.08-.948-1.856-.948-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373-.066.264-.099.48-.099.65v1.6c0 .698.214 1.287.642 1.768s.984.721 1.668.721c.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM75.699 26.588c0 1.632-.441 2.922-1.324 3.869-.789.843-1.77 1.264-2.941 1.264-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.131 0 2.076.447 2.834 1.342.755.896 1.134 2.074 1.134 3.535zm-2.172.078c0-.934-.211-1.704-.633-2.31-.461-.632-1.078-.948-1.855-.948a2.22 2.22 0 0 0-1.432.523c-.428.35-.707.807-.838 1.373-.065.264-.099.48-.099.65v1.6c0 .698.214 1.287.64 1.768.428.48.984.721 1.67.721.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM88.039 27.772c0 1.132-.393 2.053-1.182 2.764-.867.777-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.449-.829l.494-1.777c.936.566 1.963.85 3.082.85.803 0 1.428-.182 1.877-.544.447-.362.67-.848.67-1.454 0-.54-.184-.995-.553-1.364-.367-.369-.98-.712-1.836-1.029-2.33-.869-3.494-2.142-3.494-3.816 0-1.094.408-1.991 1.225-2.689.814-.699 1.9-1.048 3.258-1.048 1.211 0 2.217.211 3.02.632l-.533 1.738c-.75-.408-1.598-.612-2.547-.612-.75 0-1.336.185-1.756.553a1.58 1.58 0 0 0-.533 1.205c0 .526.203.961.611 1.303.355.316 1 .658 1.936 1.027 1.145.461 1.986 1 2.527 1.618.539.616.808 1.387.808 2.307zM95.088 23.508h-2.35v4.659c0 1.185.414 1.777 1.244 1.777.381 0 .697-.033.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.77-.473-.514-.711-1.376-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.602zM105.691 26.627c0 1.475-.422 2.686-1.264 3.633-.883.975-2.055 1.461-3.516 1.461-1.408 0-2.529-.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487.43-2.705 1.293-3.652.861-.948 2.023-1.422 3.484-1.422 1.408 0 2.541.467 3.396 1.402.818.907 1.226 2.078 1.226 3.513zm-2.212.069c0-.885-.189-1.644-.572-2.277-.447-.766-1.086-1.148-1.914-1.148-.857 0-1.508.383-1.955 1.148-.383.634-.572 1.405-.572 2.317 0 .885.189 1.644.572 2.276.461.766 1.105 1.148 1.936 1.148.814 0 1.453-.39 1.914-1.168.393-.645.591-1.412.591-2.296zM112.621 23.783a3.702 3.702 0 0 0-.672-.059c-.75 0-1.33.283-1.738.85-.355.5-.533 1.132-.533 1.895v5.035h-2.131l.02-6.574c0-1.106-.027-2.113-.08-3.021h1.857l.078 1.836h.059c.225-.631.58-1.139 1.066-1.52a2.578 2.578 0 0 1 1.541-.514c.197 0 .375.014.533.039v2.033zM122.156 26.252a5 5 0 0 1-.078.967h-6.396c.025.948.334 1.673.928 2.173.539.447 1.236.671 2.092.671.947 0 1.811-.151 2.588-.454l.334 1.48c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.313-.848-.875-1.273-2.05-1.273-3.524 0-1.447.395-2.652 1.186-3.613.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.815.846 1.823.846 3.02zm-2.033-.553c.014-.632-.125-1.178-.414-1.639-.369-.593-.936-.889-1.699-.889-.697 0-1.264.289-1.697.869-.355.461-.566 1.014-.631 1.658h4.441z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                fill: "#FFF",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.653.549-1.581.824-2.783.824-.596 0-1.106-.026-1.533-.078V6.982c.557-.09 1.157-.136 1.805-.136 1.145 0 2.008.249 2.59.747.652.563.979 1.368.979 2.416zm-1.105.029c0-.763-.202-1.348-.606-1.756-.404-.407-.994-.611-1.771-.611-.33 0-.611.022-.844.068v4.889c.129.02.365.029.708.029.802 0 1.421-.223 1.857-.669s.656-1.096.656-1.95zM54.909 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.009.718-1.727.718-.692 0-1.243-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.712-.698c.692 0 1.248.229 1.669.688.4.446.601 1.022.601 1.726zm-1.087.034c0-.435-.094-.808-.281-1.119-.22-.376-.533-.564-.94-.564-.421 0-.741.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .714-.191.94-.574.194-.317.291-.693.291-1.128zM62.765 8.719l-1.475 4.714h-.96l-.611-2.047a15.32 15.32 0 0 1-.379-1.523h-.019a11.15 11.15 0 0 1-.379 1.523l-.649 2.047h-.971l-1.387-4.714h1.077l.533 2.241c.129.53.235 1.035.32 1.513h.019c.078-.394.207-.896.389-1.503l.669-2.25h.854l.641 2.202c.155.537.281 1.054.378 1.552h.029c.071-.485.178-1.002.32-1.552l.572-2.202h1.029zM68.198 13.433H67.15v-2.7c0-.832-.316-1.248-.95-1.248a.946.946 0 0 0-.757.343 1.217 1.217 0 0 0-.291.808v2.796h-1.048v-3.366c0-.414-.013-.863-.038-1.349h.921l.049.737h.029c.122-.229.304-.418.543-.569.284-.176.602-.265.95-.265.44 0 .806.142 1.097.427.362.349.543.87.543 1.562v2.824zM71.088 13.433h-1.047V6.556h1.047v6.877zM77.258 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.01.718-1.727.718-.693 0-1.244-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.711-.698c.693 0 1.248.229 1.67.688.4.446.601 1.022.601 1.726zm-1.088.034c0-.435-.094-.808-.281-1.119-.219-.376-.533-.564-.939-.564-.422 0-.742.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .713-.191.939-.574.195-.317.291-.693.291-1.128zM82.33 13.433h-.941l-.078-.543h-.029c-.322.433-.781.65-1.377.65-.445 0-.805-.143-1.076-.427a1.339 1.339 0 0 1-.369-.96c0-.576.24-1.015.723-1.319.482-.304 1.16-.453 2.033-.446V10.3c0-.621-.326-.931-.979-.931-.465 0-.875.117-1.229.349l-.213-.688c.438-.271.979-.407 1.617-.407 1.232 0 1.85.65 1.85 1.95v1.736c0 .471.023.846.068 1.124zm-1.088-1.62v-.727c-1.156-.02-1.734.297-1.734.95 0 .246.066.43.201.553a.733.733 0 0 0 .512.184c.23 0 .445-.073.641-.218a.893.893 0 0 0 .38-.742zM88.285 13.433h-.93l-.049-.757h-.029c-.297.576-.803.864-1.514.864-.568 0-1.041-.223-1.416-.669s-.562-1.025-.562-1.736c0-.763.203-1.381.611-1.853.395-.44.879-.66 1.455-.66.633 0 1.076.213 1.328.64h.02V6.556h1.049v5.607c0 .459.012.882.037 1.27zm-1.086-1.988v-.786a1.194 1.194 0 0 0-.408-.965 1.03 1.03 0 0 0-.701-.257c-.391 0-.697.155-.922.466-.223.311-.336.708-.336 1.193 0 .466.107.844.322 1.135.227.31.533.465.916.465.344 0 .619-.129.828-.388.202-.239.301-.527.301-.863zM97.248 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.008.718-1.727.718-.691 0-1.242-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.713-.698c.691 0 1.248.229 1.668.688.4.446.601 1.022.601 1.726zm-1.086.034c0-.435-.094-.808-.281-1.119-.221-.376-.533-.564-.941-.564-.42 0-.74.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .715-.191.941-.574.193-.317.291-.693.291-1.128zM102.883 13.433h-1.047v-2.7c0-.832-.316-1.248-.951-1.248-.311 0-.562.114-.756.343s-.291.499-.291.808v2.796h-1.049v-3.366c0-.414-.012-.863-.037-1.349h.92l.049.737h.029a1.53 1.53 0 0 1 .543-.569c.285-.176.602-.265.951-.265.439 0 .805.142 1.096.427.363.349.543.87.543 1.562v2.824zM109.936 9.504h-1.154v2.29c0 .582.205.873.611.873.188 0 .344-.016.467-.049l.027.795c-.207.078-.479.117-.814.117-.414 0-.736-.126-.969-.378-.234-.252-.35-.676-.35-1.271V9.504h-.689v-.785h.689v-.864l1.027-.31v1.173h1.154v.786zM115.484 13.433h-1.049v-2.68c0-.845-.316-1.268-.949-1.268-.486 0-.818.245-1 .735a1.317 1.317 0 0 0-.049.377v2.835h-1.047V6.556h1.047v2.841h.02c.33-.517.803-.775 1.416-.775.434 0 .793.142 1.078.427.355.355.533.883.533 1.581v2.803zM121.207 10.853c0 .188-.014.346-.039.475h-3.143c.014.466.164.821.455 1.067.266.22.609.33 1.029.33.465 0 .889-.074 1.271-.223l.164.728c-.447.194-.973.291-1.582.291-.73 0-1.305-.215-1.721-.645-.418-.43-.625-1.007-.625-1.731 0-.711.193-1.303.582-1.775.406-.504.955-.756 1.648-.756.678 0 1.193.252 1.541.756.281.4.42.895.42 1.483zm-1-.271a1.411 1.411 0 0 0-.203-.805c-.182-.291-.459-.437-.834-.437a.995.995 0 0 0-.834.427 1.586 1.586 0 0 0-.311.815h2.182z"
                })
            })
        ]
    }));
};
var PlayStore = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 115,
        height: 40.019,
        viewBox: "0 0 135.716 40.019"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: 31.8,
                        y1: 183.29,
                        x2: 15.017,
                        y2: 166.508,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
                        spreadMethod: "pad",
                        id: "prefix__i",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0,
                                stopColor: "#00a0ff"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.007,
                                stopColor: "#00a1ff"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.26,
                                stopColor: "#00beff"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.512,
                                stopColor: "#00d2ff"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.76,
                                stopColor: "#00dfff"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 1,
                                stopColor: "#00e3ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: 43.834,
                        y1: 171.999,
                        x2: 19.638,
                        y2: 171.999,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
                        spreadMethod: "pad",
                        id: "prefix__j",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0,
                                stopColor: "#ffe000"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.409,
                                stopColor: "#ffbd00"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.775,
                                stopColor: "orange"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 1,
                                stopColor: "#ff9c00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: 34.827,
                        y1: 169.704,
                        x2: 12.069,
                        y2: 146.946,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
                        spreadMethod: "pad",
                        id: "prefix__k",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0,
                                stopColor: "#ff3a44"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 1,
                                stopColor: "#c31162"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        x1: 17.297,
                        y1: 191.824,
                        x2: 27.46,
                        y2: 181.661,
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
                        spreadMethod: "pad",
                        id: "prefix__l",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0,
                                stopColor: "#32a071"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.069,
                                stopColor: "#2da771"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.476,
                                stopColor: "#15cf74"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 0.801,
                                stopColor: "#06e775"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: 1,
                                stopColor: "#00f076"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__a",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        maskUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        id: "prefix__m",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__a)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0 0h124v48H0V0z",
                                fillOpacity: 0.2
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__n",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__b",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pattern", {
                        patternTransform: "matrix(1 0 0 -1 0 48)",
                        patternUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 124,
                        height: 48,
                        id: "prefix__o",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__b)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M29.625 20.695l-11.613-6.597c-.649-.371-1.231-.344-1.606-.008l-.058-.063.058-.058c.375-.336.957-.36 1.606.011l11.687 6.641-.074.074z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__c",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        maskUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        id: "prefix__p",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__c)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0 0h124v48H0V0z",
                                fillOpacity: 0.12
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__q",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__d",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pattern", {
                        patternTransform: "matrix(1 0 0 -1 0 48)",
                        patternUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 124,
                        height: 48,
                        id: "prefix__r",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__d)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M16.348 14.145c-.235.246-.371.628-.371 1.125v-.118c0-.496.136-.879.371-1.125l.058.063-.058.055z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__e",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        maskUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        id: "prefix__s",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__e)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0 0h124v48H0V0z",
                                fillOpacity: 0.12
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__t",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__f",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pattern", {
                        patternTransform: "matrix(1 0 0 -1 0 48)",
                        patternUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 124,
                        height: 48,
                        id: "prefix__u",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__f)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M33.613 22.961l-3.988-2.266.074-.074 3.914 2.223c.559.316.836.734.836 1.156-.047-.379-.332-.75-.836-1.039z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__g",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                        maskUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 1,
                        height: 1,
                        id: "prefix__v",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__g)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M0 0h124v48H0V0z",
                                fillOpacity: 0.25
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__w",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "prefix__h",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pattern", {
                        patternTransform: "matrix(1 0 0 -1 0 48)",
                        patternUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 124,
                        height: 48,
                        id: "prefix__x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                            clipPath: "url(#prefix__h)",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                d: "M18.012 33.902l15.601-8.863c.508-.289.789-.66.836-1.039 0 .418-.277.836-.836 1.156L18.012 34.02c-1.117.632-2.035.105-2.035-1.176v-.114c0 1.278.918 1.805 2.035 1.172z",
                                fill: "#fff"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M130.54 39.943H5.24c-2.755 0-5.012-2.23-5.012-4.954V5.267C.228 2.544 2.485.314 5.24.314h125.3c2.755 0 5.011 2.23 5.011 4.953V34.99c0 2.724-2.256 4.954-5.012 4.954z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M130.54 1.108c2.32 0 4.208 1.866 4.208 4.16v29.721c0 2.294-1.888 4.16-4.209 4.16H5.24c-2.32 0-4.208-1.866-4.208-4.16V5.267c0-2.293 1.888-4.16 4.208-4.16h125.3m0-.793H5.24C2.485.314.228 2.544.228 5.267V34.99c0 2.724 2.257 4.954 5.012 4.954h125.3c2.755 0 5.011-2.23 5.011-4.954V5.267c0-2.723-2.256-4.953-5.012-4.953z",
                fill: "#a6a6a6"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M45.934 16.195c0 .668-.2 1.203-.594 1.602-.453.473-1.043.711-1.766.711a2.426 2.426 0 0 1-1.765-.719c-.485-.484-.727-1.078-.727-1.789 0-.711.242-1.305.727-1.785a2.414 2.414 0 0 1 1.765-.723c.344 0 .672.071.985.203.312.133.566.313.75.535l-.418.422c-.321-.379-.758-.566-1.317-.566-.504 0-.941.176-1.312.531-.367.356-.551.817-.551 1.383 0 .566.184 1.031.551 1.387a1.85 1.85 0 0 0 1.312.531c.535 0 .985-.18 1.34-.535.234-.235.367-.559.402-.973h-1.742v-.578h2.324c.028.125.036.246.036.363zM49.621 14.191h-2.183v1.52h1.968v.578h-1.968v1.52h2.183v.589H46.82v-4.796h2.801v.589zM52.223 18.398h-.618v-4.207h-1.339v-.589h3.297v.589h-1.34v4.207zM55.949 18.398v-4.796h.617v4.796h-.617zM59.301 18.398h-.613v-4.207h-1.344v-.589h3.301v.589h-1.344v4.207zM66.887 17.781c-.473.485-1.059.727-1.758.727-.703 0-1.289-.242-1.762-.727-.472-.484-.707-1.078-.707-1.781 0-.703.235-1.297.707-1.781.473-.485 1.059-.727 1.762-.727.695 0 1.281.242 1.754.731.476.488.711 1.078.711 1.777 0 .703-.235 1.297-.707 1.781zm-3.063-.402c.356.359.789.539 1.305.539.512 0 .949-.18 1.301-.539.355-.359.535-.82.535-1.379s-.18-1.02-.535-1.379a1.756 1.756 0 0 0-1.301-.539c-.516 0-.949.18-1.305.539-.355.359-.535.82-.535 1.379s.18 1.02.535 1.379zM68.461 18.398v-4.796h.75l2.332 3.73h.027l-.027-.922v-2.808h.617v4.796h-.644l-2.442-3.914h-.027l.027.926v2.988h-.613z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: 0.16,
                strokeMiterlimit: 10,
                transform: "matrix(1.25299 0 0 1.23841 -9.796 -9.594)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M68.526 21.865c-2.354 0-4.277 1.77-4.277 4.214 0 2.424 1.923 4.213 4.277 4.213 2.36 0 4.283-1.79 4.283-4.213 0-2.443-1.923-4.214-4.283-4.214zm0 6.768c-1.291 0-2.403-1.054-2.403-2.554 0-1.52 1.112-2.555 2.403-2.555 1.292 0 2.409 1.035 2.409 2.555 0 1.5-1.117 2.554-2.409 2.554zm-9.333-6.768c-2.36 0-4.278 1.77-4.278 4.214 0 2.424 1.918 4.213 4.278 4.213 2.358 0 4.278-1.79 4.278-4.213 0-2.443-1.92-4.214-4.278-4.214zm0 6.768c-1.293 0-2.408-1.054-2.408-2.554 0-1.52 1.115-2.555 2.408-2.555 1.292 0 2.403 1.035 2.403 2.555 0 1.5-1.111 2.554-2.403 2.554zm-11.107-5.477v1.791h4.327c-.127 1-.465 1.736-.984 2.249-.631.62-1.615 1.307-3.343 1.307a4.722 4.722 0 0 1-4.747-4.756 4.722 4.722 0 0 1 4.747-4.756c1.44 0 2.488.557 3.26 1.277l1.277-1.262c-1.08-1.02-2.52-1.804-4.537-1.804-3.65 0-6.72 2.936-6.72 6.545s3.07 6.545 6.72 6.545c1.974 0 3.456-.639 4.621-1.838 1.194-1.18 1.567-2.84 1.567-4.18 0-.416-.035-.798-.098-1.118h-6.09zm45.416 1.389c-.352-.943-1.438-2.68-3.651-2.68-2.193 0-4.018 1.707-4.018 4.214 0 2.36 1.806 4.213 4.228 4.213a4.238 4.238 0 0 0 3.554-1.868l-1.453-.957c-.485.701-1.146 1.166-2.1 1.166-.949 0-1.63-.43-2.065-1.277l5.702-2.332-.197-.48zm-5.814 1.403c-.049-1.625 1.277-2.457 2.227-2.457.744 0 1.376.367 1.586.894l-3.813 1.563zm-4.634 4.088h1.874V17.652h-1.874v12.384zm-3.07-7.233h-.063c-.421-.493-1.224-.938-2.242-.938-2.135 0-4.087 1.852-4.087 4.228 0 2.361 1.952 4.199 4.087 4.199 1.018 0 1.821-.45 2.242-.957h.063v.604c0 1.611-.871 2.477-2.276 2.477-1.145 0-1.855-.817-2.149-1.505l-1.63.673c.47 1.117 1.714 2.491 3.78 2.491 2.197 0 4.051-1.278 4.051-4.387V22.12h-1.776v.682zm-2.144 5.83c-1.292 0-2.373-1.07-2.373-2.54 0-1.485 1.081-2.569 2.373-2.569 1.273 0 2.277 1.084 2.277 2.569 0 1.47-1.004 2.54-2.277 2.54zm24.438-10.981h-4.483v12.384h1.87v-4.693h2.613c2.076 0 4.112-1.485 4.112-3.846 0-2.36-2.04-3.845-4.112-3.845zm.049 5.969h-2.663v-4.247h2.663a2.161 2.161 0 0 1 2.193 2.123c0 .958-.797 2.124-2.193 2.124zm11.556-1.78c-1.35 0-2.755.59-3.333 1.896l1.66.687c.356-.687 1.013-.91 1.707-.91.97 0 1.954.576 1.969 1.593v.13c-.339-.193-1.063-.48-1.954-.48-1.787 0-3.607.973-3.607 2.787 0 1.66 1.463 2.728 3.109 2.728 1.258 0 1.952-.56 2.388-1.213h.064v.957h1.805v-4.75c0-2.196-1.659-3.425-3.808-3.425zm-.225 6.787c-.612 0-1.464-.3-1.464-1.05 0-.958 1.063-1.326 1.983-1.326.823 0 1.209.18 1.709.416-.147 1.147-1.146 1.96-2.228 1.96zm10.611-6.516l-2.148 5.369h-.064l-2.222-5.369h-2.016l3.338 7.503-1.905 4.174h1.954l5.143-11.677h-2.08zm-16.851 7.924h1.874V17.652h-1.874v12.384z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.348 33.969c-.235-.246-.371-.629-.371-1.125V15.152c0-.496.136-.879.371-1.125l.058-.054 9.914 9.91v.234l-9.914 9.91-.058-.058z",
                fill: "url(#prefix__i)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M29.621 20.578l-3.301 3.305v.234l3.305 3.305.074-.043 3.914-2.227c1.117-.632 1.117-1.672 0-2.308l-3.914-2.223-.078-.043z",
                fill: "url(#prefix__j)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M29.699 20.621L26.32 24l-9.972-9.973c.371-.39.976-.437 1.664-.047l11.687 6.641",
                fill: "url(#prefix__k)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M29.699 27.379L18.012 34.02c-.688.386-1.293.339-1.664-.051L26.32 24l3.379 3.379z",
                fill: "url(#prefix__l)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                mask: "url(#prefix__m)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    clipPath: "url(#prefix__n)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M0 0h124v48H0V0z",
                        fill: "url(#prefix__o)"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                mask: "url(#prefix__p)",
                transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    clipPath: "url(#prefix__q)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        d: "M0 0h124v48H0V0z",
                        fill: "url(#prefix__r)"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    mask: "url(#prefix__s)",
                    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        clipPath: "url(#prefix__t)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z",
                            fill: "url(#prefix__u)"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                    mask: "url(#prefix__v)",
                    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                        clipPath: "url(#prefix__w)",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M0 0h124v48H0V0z",
                            fill: "url(#prefix__x)"
                        })
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductAlternativesCard.tsx






function ProductAlternativesCard(param) {
    var product = param.product, renderLinkWrap = param.renderLinkWrap;
    if (!product.alternatives || product.alternatives.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardHeader */.Ol, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimilarProductsCardIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Similar Products",
                            id: "ru28zW"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardBody */.eW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                    gridRowGap: 4,
                    children: product.alternatives.map(function(product) {
                        var anchor = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: "https://govlaunch.com/products/".concat(product.slug),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                        src: product.logo,
                                        name: product.name,
                                        size: "md"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
                                        ml: 4,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                            fontSize: "sm",
                                            color: "gray.600",
                                            fontWeight: "semibold",
                                            children: product.name
                                        })
                                    })
                                ]
                            })
                        }, product._id);
                        return renderLinkWrap ? renderLinkWrap(product, anchor) : anchor;
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/utils/findInUnionByTypename.ts
function byTypename(lookingFor) {
    return function(value) {
        return value.__typename === lookingFor;
    };
}
function findInUnionByTypename(union, lookingFor) {
    return union.find(byTypename(lookingFor)) || null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductDeploymentCard.tsx







function ProductDeploymentCard(param) {
    var product = param.product;
    var intl = (0,useIntl/* default */.Z)();
    if (product.deployment.length === 0) {
        return null;
    }
    var webDeployment = findInUnionByTypename(product.deployment, "WebProductDeployment");
    var desktopDeployment = findInUnionByTypename(product.deployment, "DesktopProductDeployment");
    var appStoreDeployment = findInUnionByTypename(product.deployment, "AppStoreProductDeployment");
    var playStoreDeployment = findInUnionByTypename(product.deployment, "PlayStoreProductDeployment");
    if (!(webDeployment || desktopDeployment || appStoreDeployment || playStoreDeployment)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardHeader */.Ol, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeploymentCardIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Deployment",
                            id: "OyvHWp"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardBody */.eW, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                        gridTemplateColumns: "1fr 1fr",
                        gridRowGap: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontWeight: "semibold",
                                        fontSize: "sm",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Delivery",
                                            id: "drqP2L"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontSize: "sm",
                                        children: [
                                            desktopDeployment ? intl.formatMessage({
                                                defaultMessage: "Desktop",
                                                id: "tHSb8p"
                                            }) : null,
                                            appStoreDeployment || playStoreDeployment ? intl.formatMessage({
                                                defaultMessage: "Mobile",
                                                id: "GWtmtu"
                                            }) : null,
                                            webDeployment ? intl.formatMessage({
                                                defaultMessage: "Web",
                                                id: "B6CB37"
                                            }) : null, 
                                        ].filter(Boolean).join(" / ")
                                    })
                                ]
                            }),
                            webDeployment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                fontWeight: "semibold",
                                                fontSize: "sm",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Mobile Responsive",
                                                    id: "xVXe3M"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                fontSize: "sm",
                                                children: webDeployment.mobileResponsive ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Yes",
                                                    id: "a5msuh"
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "No",
                                                    id: "oUWADl"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                fontWeight: "semibold",
                                                fontSize: "sm",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Browser Support",
                                                    id: "VVpE+u"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                fontSize: "sm",
                                                children: webDeployment.supportedBrowsers.join(" / ")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            desktopDeployment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontWeight: "semibold",
                                        fontSize: "sm",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Platforms",
                                            id: "6GGPoo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontSize: "sm",
                                        children: desktopDeployment.platforms.join(" / ")
                                    })
                                ]
                            })
                        ]
                    }),
                    (appStoreDeployment || playStoreDeployment) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Mobile",
                                    id: "GWtmtu"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Grid */.rj, {
                                gridTemplateColumns: "1fr 1fr",
                                columnGap: 4,
                                mt: 1,
                                children: [
                                    appStoreDeployment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                            href: appStoreDeployment.linkHref,
                                            fontSize: "sm",
                                            external: "govlaunch",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppStore, {})
                                        })
                                    }),
                                    playStoreDeployment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                            href: playStoreDeployment.linkHref,
                                            fontSize: "sm",
                                            external: "govlaunch",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayStore, {})
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(80022);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(22770);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(74239);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/utils/getHostname.ts
function getHostname(url) {
    if (!url) {
        return null;
    }
    return url.replace("http://", "").replace("https://", "").replace("www.", "").split(/[/?#]/)[0];
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductDetailsCard.tsx










function ProductDetailsCard(param) {
    var product = param.product;
    var socialMedia = product.socialMedia;
    var intl = (0,useIntl/* default */.Z)();
    var ASSISTIVE_TECHNOLOGIES = {
        SCREEN_READER: intl.formatMessage({
            defaultMessage: "Screen Reader",
            id: "A/EnQi"
        }),
        SCREEN_MAGNIFICATION: intl.formatMessage({
            defaultMessage: "Screen Magnification",
            id: "9aqVDo"
        }),
        TEXT_READER: intl.formatMessage({
            defaultMessage: "Text Reader",
            id: "p8ggQu"
        }),
        SPEECH_INPUT: intl.formatMessage({
            defaultMessage: "Speech Input",
            id: "CeYzvW"
        }),
        ALTERNATIVE_INPUT_DEVICE: intl.formatMessage({
            defaultMessage: "Alternative Input Device",
            id: "EnL02F"
        })
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardHeader */.Ol, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductDetailsCardIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Product Details",
                            id: "ee4CDp"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardBody */.eW, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Grid */.rj, {
                        gridAutoColumns: "max-content",
                        gridColumnGap: 4,
                        gridAutoFlow: "column",
                        children: [
                            product.releasedYear && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontWeight: "semibold",
                                        fontSize: "sm",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Year Released",
                                            id: "L1NbGa"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontSize: "sm",
                                        children: product.releasedYear
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontWeight: "semibold",
                                        fontSize: "sm",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Free Trial?",
                                            id: "b2Dran"
                                        })
                                    }),
                                    product.freeTrial ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                        external: "outside-govlaunch",
                                        href: product.freeTrial.linkHref,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                            fontSize: "sm",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Yes",
                                                id: "a5msuh"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontSize: "sm",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "No",
                                            id: "oUWADl"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Pricing Available?",
                                    id: "Pk7PsC"
                                })
                            }),
                            product.pricingPage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                external: "outside-govlaunch",
                                href: product.pricingPage,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                    fontSize: "sm",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Yes",
                                        id: "a5msuh"
                                    })
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "No",
                                    id: "oUWADl"
                                })
                            })
                        ]
                    }),
                    product.assistiveTechnologiesCompatibility.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Accessibility",
                                    id: "fgCBG8"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                children: product.assistiveTechnologiesCompatibility.map(function(technology) {
                                    return ASSISTIVE_TECHNOLOGIES[technology];
                                }).join(" / ")
                            })
                        ]
                    }),
                    product.languagesOffered && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Languages",
                                    id: "GsBRWL"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                children: product.languagesOffered
                            })
                        ]
                    }),
                    product.certifications.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Regulatory Compliance or Certifications",
                                    id: "MVKIvU"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                children: product.certifications.join(" / ")
                            })
                        ]
                    }),
                    product.openSource && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Open Source",
                                    id: "Xd0J7Y"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                href: product.openSource.linkHref,
                                fontSize: "sm",
                                external: "outside-govlaunch",
                                children: getHostname(product.openSource.linkHref)
                            })
                        ]
                    }),
                    socialMedia && hasSocialMedia(socialMedia) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
                                height: "1px",
                                bg: "gray.100",
                                mt: 1
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                mt: 4,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        color: "blue.600",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Follow us",
                                            id: "l1XTI5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                                        marginLeft: "auto",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                                            gridAutoFlow: "column",
                                            gridAutoColumns: "max-content",
                                            gridColumnGap: 2,
                                            alignItems: "center",
                                            children: [
                                                socialMedia.linkedin && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    href: socialMedia.linkedin,
                                                    external: "outside-redirect",
                                                    title: "linkedin-".concat(product.name),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                                                        size: 22,
                                                        round: true
                                                    })
                                                }),
                                                socialMedia.twitter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    href: socialMedia.twitter,
                                                    external: "outside-redirect",
                                                    title: "twitter-".concat(product.name),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                                                        size: 22,
                                                        round: true
                                                    })
                                                }),
                                                socialMedia.facebook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    href: socialMedia.facebook,
                                                    external: "outside-redirect",
                                                    title: "facebook-".concat(product.name),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                                                        size: 22,
                                                        round: true
                                                    })
                                                }),
                                                socialMedia.instagram && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    href: socialMedia.instagram,
                                                    external: "outside-redirect",
                                                    title: "instagram-".concat(product.name),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstagramIcon, {
                                                        height: 22
                                                    })
                                                }),
                                                socialMedia.youtube && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                                    href: socialMedia.youtube,
                                                    external: "outside-redirect",
                                                    title: "youtube-".concat(product.name),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeIcon, {
                                                        height: 22,
                                                        width: 29
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function hasSocialMedia(socialMedia) {
    if (!socialMedia) {
        return false;
    }
    return [
        socialMedia.facebook,
        socialMedia.twitter,
        socialMedia.instagram,
        socialMedia.linkedin,
        socialMedia.youtube, 
    ].some(Boolean);
}
var InstagramIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 551.034 551.034"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "prefix__a",
                gradientUnits: "userSpaceOnUse",
                x1: 275.517,
                y1: 4.57,
                x2: 275.517,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M386.878 0H164.156C73.64 0 0 73.64 0 164.156v222.722c0 90.516 73.64 164.156 164.156 164.156h222.722c90.516 0 164.156-73.64 164.156-164.156V164.156C551.033 73.64 477.393 0 386.878 0zM495.6 386.878c0 60.045-48.677 108.722-108.722 108.722H164.156c-60.045 0-108.722-48.677-108.722-108.722V164.156c0-60.046 48.677-108.722 108.722-108.722h222.722c60.045 0 108.722 48.676 108.722 108.722v222.722z",
                fill: "url(#prefix__a)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "prefix__b",
                gradientUnits: "userSpaceOnUse",
                x1: 275.517,
                y1: 4.57,
                x2: 275.517,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M275.517 133C196.933 133 133 196.933 133 275.516s63.933 142.517 142.517 142.517S418.034 354.1 418.034 275.516 354.101 133 275.517 133zm0 229.6c-48.095 0-87.083-38.988-87.083-87.083s38.989-87.083 87.083-87.083c48.095 0 87.083 38.988 87.083 87.083 0 48.094-38.989 87.083-87.083 87.083z",
                fill: "url(#prefix__b)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                id: "prefix__c",
                gradientUnits: "userSpaceOnUse",
                x1: 418.31,
                y1: 4.57,
                x2: 418.31,
                y2: 549.72,
                gradientTransform: "matrix(1 0 0 -1 0 554)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0,
                        stopColor: "#e09b3d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.3,
                        stopColor: "#c74c4d"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 0.6,
                        stopColor: "#c21975"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                        offset: 1,
                        stopColor: "#7024c4"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 418.31,
                cy: 134.07,
                r: 34.15,
                fill: "url(#prefix__c)"
            })
        ]
    }));
};
var YoutubeIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 461 327"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M365.257.393H95.744C42.866.393 0 43.259 0 96.137v134.728c0 52.878 42.866 95.744 95.744 95.744h269.513c52.878 0 95.744-42.866 95.744-95.744V96.137c0-52.878-42.866-95.744-95.744-95.744zm-64.751 169.663l-126.06 60.123c-3.359 1.602-7.239-.847-7.239-4.568V101.607c0-3.774 3.982-6.22 7.348-4.514l126.06 63.881c3.748 1.899 3.683 7.274-.109 9.082z",
            fill: "#F61C0D",
            fillRule: "nonzero"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/utils/isStockImage.ts
function isStockImage(imageUrl) {
    return imageUrl.startsWith("https://s3.amazonaws.com/static.govlaunch.com") || imageUrl.startsWith("https://static.govlaunch.com/resources/gallery");
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductGallery.tsx






var isYoutube = function(url) {
    return url.includes("youtube.com") || url.includes("youtu.be");
};
var isVimeo = function(url) {
    return url.includes("vimeo.com");
};
function ProductGallery(param) {
    var product = param.product;
    var ref, ref1;
    var screenshots = ((ref = product.screenshots) === null || ref === void 0 ? void 0 : ref.filter(function(image) {
        return !isStockImage(image.url);
    })) || [];
    var videos = product.enrichedProfile ? ((ref1 = product.videos) === null || ref1 === void 0 ? void 0 : ref1.filter(function(url) {
        return !isStockImage(url);
    })) || [] : [];
    var videoMedias = videos.map(function(video, index) {
        var type = web/* IMediaType.Image */.BB.Image;
        if (isYoutube(video)) {
            type = web/* IMediaType.Youtube */.BB.Youtube;
        }
        if (isVimeo(video)) {
            type = web/* IMediaType.Vimeo */.BB.Vimeo;
        }
        return {
            url: video,
            type: type,
            alt: "".concat(product.name, " video ").concat(index + 1)
        };
    });
    var screenshotMedias = screenshots.map(function(screenshot) {
        return {
            url: screenshot.url,
            type: web/* IMediaType.Image */.BB.Image,
            alt: screenshot.alt
        };
    });
    var medias = (0,_to_consumable_array/* default */.Z)(videoMedias).concat((0,_to_consumable_array/* default */.Z)(screenshotMedias));
    if (medias.length === 0) {
        medias.push({
            type: web/* IMediaType.Image */.BB.Image,
            url: "https://static.govlaunch.com/resources/gallery/0".concat(Math.round(Math.random() * 5 + 1), ".png"),
            alt: "".concat(product.name, " gallery image")
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* GalleryState */.e9, {
        medias: medias,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GallerySelectedMedia */.kU, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
                height: "1px",
                bg: "gray.100",
                mt: 3
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GalleryThumbnails */.EZ, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/numeral@2.0.6/node_modules/numeral/numeral.js
var numeral = __webpack_require__(4587);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/hooks/useShowMoreCounter.ts

function useShowMoreCounter(total, limit) {
    var ref = (0,react.useState)(1), count = ref[0], setCount = ref[1];
    var offset = Math.min(count * limit, total);
    return {
        offset: offset,
        hasMore: count * limit < total,
        hasLess: count > 1,
        showMore: function() {
            return setCount(count + 1);
        },
        showLess: function() {
            return setCount(count - 1);
        }
    };
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductGovernments.tsx









function ProductGovernments(_param) {
    var product = _param.product, renderLinkWrap = _param.renderLinkWrap, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "renderLinkWrap"
    ]);
    var ref;
    var governments = ((ref = product.governments) === null || ref === void 0 ? void 0 : ref.items) || [];
    var totalCount = governments.length;
    var ref1 = useShowMoreCounter(totalCount || 0, 9), offset = ref1.offset, hasMore = ref1.hasMore, showMore = ref1.showMore;
    var items = governments.slice(0, offset) || [];
    if (items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bg: "white",
        borderRadius: "md",
        border: "1px",
        borderColor: "gray.100"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                borderBottom: "1px",
                borderColor: "gray.100",
                py: 3,
                px: 8,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                    as: "h3",
                    color: "gray.900",
                    fontWeight: "bold",
                    fontSize: "lg",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Governments ({totalCount})",
                        id: "96+kGo",
                        values: {
                            totalCount: totalCount
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                py: 3,
                px: 8,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Grid */.rj, {
                        gridTemplateColumns: [
                            "1fr",
                            "1fr",
                            "1fr 1fr",
                            "1fr 1fr 1fr"
                        ],
                        gridRowGap: 6,
                        children: items.map(function(government) {
                            var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                        maxWidth: "220px",
                                        textAlign: "center",
                                        "aria-label": government.name,
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                            children: [
                                                government.name,
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                                " ",
                                                government.city.countryName
                                            ]
                                        }),
                                        bg: "blue.600",
                                        py: 2,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                            position: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                    size: "lg",
                                                    src: government.logo,
                                                    name: government.name
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                    position: "absolute",
                                                    bottom: 1,
                                                    right: -3,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                        countryCode: government.city.country,
                                                        width: 24,
                                                        height: 14
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                        ml: 4,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                display: "flex",
                                                alignItems: "center",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                    fontWeight: 600,
                                                    fontSize: 16,
                                                    children: government.name
                                                })
                                            }),
                                            government.city.population !== null && government.city.population > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                                                as: "span",
                                                fontSize: 12,
                                                children: [
                                                    government.city.population !== null && government.city.population > 1000 ? numeral_default()(government.city.population).format("0.0a") : government.city.population,
                                                    " ",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "population",
                                                        id: "Hmd2rc"
                                                    })
                                                ]
                                            }),
                                            government.city.population !== null && government.budget !== null && government.budget > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                as: "span",
                                                children: " / "
                                            }),
                                            !!government.budget && government.budget > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                as: "span",
                                                fontSize: 12,
                                                children: getFormattedBudget(government.budget, government.currency)
                                            })
                                        ]
                                    })
                                ]
                            }, government._id);
                            return renderLinkWrap ? renderLinkWrap(government, children) : children;
                        })
                    }),
                    hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justify: "center",
                        mt: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            variant: "secondary",
                            size: "sm",
                            onClick: showMore,
                            rightIcon: function(props) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    width: "24",
                                    height: "12",
                                    viewBox: "0 0 24 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                }, props), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M2 2.5L11.7436 9.55882L22 2.5",
                                        stroke: "currentColor",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }));
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Show more",
                                id: "aWpBzj"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
function getFormattedBudget(budget, currency) {
    var formatted = budget > 1000 ? numeral_default()(budget).format("0.0a") : budget;
    if (currency === "USD") {
        return "$".concat(formatted);
    }
    if (currency === "GBP") {
        return "\xa3".concat(formatted);
    }
    if (currency === "EUR") {
        return "€".concat(formatted);
    }
    if (currency === "CAD") {
        return "CA$".concat(formatted);
    }
    if (currency === "AUD") {
        return "AU$".concat(formatted);
    }
    if (currency === "NZD") {
        return "NZ$".concat(formatted);
    }
    if (currency === "ZAR") {
        return "R".concat(formatted);
    }
    if (currency === "BRL") {
        return "R$".concat(formatted);
    }
    if (currency === "SEK") {
        return "SEK".concat(formatted);
    }
    if (currency === "DKK") {
        return "DKK".concat(formatted);
    }
    if (currency === "MXN") {
        return "MX$".concat(formatted);
    }
    if (currency === "ARS") {
        return "ARS".concat(formatted);
    }
    return "".concat(formatted);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductHeader.tsx







function ProductHeader(_param) {
    var product = _param.product, renderTagLinkWrap = _param.renderTagLinkWrap, translationButton = _param.translationButton, isMobile = _param.isMobile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "renderTagLinkWrap",
        "translationButton",
        "isMobile"
    ]);
    var tags = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
        mt: 3,
        children: product.tags.map(function(tag) {
            var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tag */.Vp, {
                mr: 2,
                mb: 2,
                color: "black",
                title: tag.name,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                    children: tag.name
                })
            }, tag._id);
            return renderTagLinkWrap ? renderTagLinkWrap(tag, children) : children;
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                alignItems: [
                    "flex-start",
                    "flex-start",
                    "flex-start",
                    "center"
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                        src: product.logo,
                        name: product.name,
                        size: "xl",
                        variant: product.isDisruptor ? "disruptor" : undefined
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                        ml: 6,
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                                        as: "h1",
                                        size: "xl",
                                        color: "blue.600",
                                        children: product.name
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            paddingTop: !isMobile ? "8px" : "0px"
                                        },
                                        children: translationButton ? translationButton() : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                mt: 2,
                                fontSize: "md",
                                title: product.description || undefined,
                                children: product.description
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
                                display: [
                                    "none",
                                    "none",
                                    "none",
                                    "block"
                                ],
                                children: tags
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, {
                display: [
                    "block",
                    "block",
                    "block",
                    "none"
                ],
                children: tags
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductIntegrationsCard.tsx




function ProductIntegrationsCard(param) {
    var product = param.product, renderLinkWrap = param.renderLinkWrap;
    var integrations = product.integrations || [];
    if (integrations.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardHeader */.Ol, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Marketplace Integrations",
                        id: "s6xCoe"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardBody */.eW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    css: {
                        listStyleType: "none"
                    },
                    children: integrations.map(function(integration) {
                        var anchor = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: "/products/".concat(integration.slug),
                            fontSize: "sm",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                as: "span",
                                clamp: 1,
                                children: integration.name
                            })
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: renderLinkWrap ? renderLinkWrap(integration, anchor) : anchor
                        }, integration._id);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductNewsworthy.tsx







function ProductNewsworthy(_param) {
    var product = _param.product, stacked = _param.stacked, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "stacked"
    ]);
    if (!product.newsworthy || product.newsworthy.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "grid"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                fontWeight: "bold",
                fontSize: "lg",
                pl: [
                    0,
                    0,
                    8
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Newsworthy",
                    id: "JhItYg"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* NewsworthyScrollbarsContainer */.pT, {
                stacked: stacked,
                mt: 1,
                children: product.newsworthy.map(function(newsworthy) {
                    var ref;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* NewsworthyItem */.oy, {
                        newsworthy: {
                            url: newsworthy.url || "",
                            description: newsworthy.description,
                            favicon: newsworthy.favicon,
                            title: newsworthy.title || "",
                            siteName: newsworthy.siteName || ""
                        },
                        flexDirection: ((ref = product.newsworthy) === null || ref === void 0 ? void 0 : ref.length) === 1 ? "column" : "row"
                    }, newsworthy.url || Math.random().toString(16));
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(18648);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(5000);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductSharing.tsx







function ProductSharing(param) {
    var product = param.product, onToggleBookmark = param.onToggleBookmark;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
        gridAutoFlow: "column",
        gridColumnGap: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookShareButton/* default */.Z, {
                url: getCurrentUrl() || "/products/".concat(product.slug),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                    alignItems: "center",
                    gridAutoFlow: "column",
                    gridColumnGap: 2,
                    p: 1,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: "sm",
                            fontWeight: "normal",
                            color: "blue.800",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "share",
                                id: "lRcBEU"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                            round: true,
                            size: 22
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterShareButton/* default */.Z, {
                url: getCurrentUrl() || "/products/".concat(product.slug),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                    alignItems: "center",
                    gridAutoFlow: "column",
                    gridColumnGap: 2,
                    p: 1,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: "sm",
                            fontWeight: "normal",
                            color: "blue.500",
                            children: "tweet"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                            round: true,
                            size: 22
                        })
                    ]
                })
            }),
            onToggleBookmark && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                "aria-label": product.viewerDidBookmark ? intl.formatMessage({
                    defaultMessage: "remove bookmark",
                    id: "ucGBsJ"
                }) : intl.formatMessage({
                    defaultMessage: "bookmark",
                    id: "xYk4VA"
                }),
                variantColor: "teal",
                size: "sm",
                variant: "outline",
                onClick: function() {
                    return onToggleBookmark(product);
                },
                rightIcon: function(props) {
                    if (product.viewerDidBookmark) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: 13,
                            height: 20,
                            viewBox: "0 0 14 20",
                            fill: "none"
                        }, props), {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M2.691 1.726c-.679 0-1.191.53-1.191 1.13v14.929l5.074-4.914 5.073 4.915V2.856c0-.6-.513-1.13-1.191-1.13H2.69zM0 2.856C0 1.382 1.23.226 2.691.226h7.765c1.461 0 2.691 1.157 2.691 2.63v15.792c0 .644-.532 1.126-1.138 1.126h-.001c-.293 0-.578-.113-.793-.319l-.003-.002-4.638-4.493-4.637 4.49-.001.001c-.327.318-.81.407-1.226.24A1.125 1.125 0 010 18.647V2.856z",
                                    fill: "#28D094"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    d: "M1.5 2.856c0-.6.512-1.13 1.191-1.13h7.765c.678 0 1.191.53 1.191 1.13v14.93L6.574 12.87 1.5 17.785V2.856z",
                                    fill: "#28D094"
                                })
                            ]
                        }));
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        width: 13,
                        height: 20,
                        viewBox: "0 0 13 20",
                        xmlns: "http://www.w3.org/2000/svg"
                    }, props), {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            d: "M2.9445 2.05874C2.30562 2.05874 1.82339 2.55742 1.82339 3.12222V17.1728L6.59853 12.5483L11.3736 17.1735V3.12222C11.3736 2.55795 10.8912 2.05874 10.2525 2.05874H2.9445ZM0.411621 3.12222C0.411621 1.73505 1.5693 0.646973 2.9445 0.646973H10.2525C11.6279 0.646973 12.7854 1.73594 12.7854 3.12222V17.9849C12.7854 18.5913 12.2842 19.0446 11.7141 19.0446H11.713C11.4375 19.0442 11.1689 18.9388 10.9666 18.7447L10.9643 18.7424L6.59845 14.5137L2.23437 18.7401C2.2341 18.7404 2.23383 18.7406 2.23355 18.7409C1.92612 19.04 1.47166 19.1241 1.08007 18.9661C0.685916 18.8083 0.411499 18.4267 0.411621 17.9848V3.12222Z",
                            fill: "currentColor"
                        })
                    }));
                },
                children: product.viewerDidBookmark ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "saved",
                    id: "dxFzER"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "save",
                    id: "EjXcOc"
                })
            })
        ]
    });
};
function getCurrentUrl() {
    if (false) {}
    return window.location.href;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductSiblingsCard.tsx




function ProductSiblingsCard(param) {
    var product = param.product, renderLinkWrap = param.renderLinkWrap;
    var ref;
    var siblings = product.siblings || [];
    if (siblings.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardHeader */.Ol, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "More By {companyName}",
                        id: "gRkbZU",
                        values: {
                            companyName: (ref = product.company) === null || ref === void 0 ? void 0 : ref.name
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardBody */.eW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    css: {
                        listStyleType: "none"
                    },
                    children: siblings.map(function(sibling) {
                        var anchor = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: "/products/".concat(product.slug),
                            fontSize: "sm",
                            children: sibling.name
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: renderLinkWrap ? renderLinkWrap(sibling, anchor) : anchor
                        }, sibling._id);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/graphql/types.ts
var IAllSponsorshipsFilter;
(function(IAllSponsorshipsFilter) {
    IAllSponsorshipsFilter["All"] = "ALL";
    IAllSponsorshipsFilter["Archived"] = "ARCHIVED";
})(IAllSponsorshipsFilter || (IAllSponsorshipsFilter = {}));
var IAssistiveTechnology;
(function(IAssistiveTechnology) {
    IAssistiveTechnology["AlternativeInputDevice"] = "ALTERNATIVE_INPUT_DEVICE";
    IAssistiveTechnology["ScreenMagnification"] = "SCREEN_MAGNIFICATION";
    IAssistiveTechnology["ScreenReader"] = "SCREEN_READER";
    IAssistiveTechnology["SpeechInput"] = "SPEECH_INPUT";
    IAssistiveTechnology["TextReader"] = "TEXT_READER";
})(IAssistiveTechnology || (IAssistiveTechnology = {}));
var IBookmarkType;
(function(IBookmarkType) {
    IBookmarkType["Collection"] = "COLLECTION";
    IBookmarkType["Post"] = "POST";
    IBookmarkType["Product"] = "PRODUCT";
    IBookmarkType["Project"] = "PROJECT";
    IBookmarkType["Story"] = "STORY";
})(IBookmarkType || (IBookmarkType = {}));
var IBulkTaggingEntityType;
(function(IBulkTaggingEntityType) {
    IBulkTaggingEntityType["Project"] = "PROJECT";
})(IBulkTaggingEntityType || (IBulkTaggingEntityType = {}));
var IBulkTaggingModifyStrategy;
(function(IBulkTaggingModifyStrategy) {
    IBulkTaggingModifyStrategy["Add"] = "ADD";
    IBulkTaggingModifyStrategy["Overwrite"] = "OVERWRITE";
    IBulkTaggingModifyStrategy["Remove"] = "REMOVE";
})(IBulkTaggingModifyStrategy || (IBulkTaggingModifyStrategy = {}));
var IChargeStatus;
(function(IChargeStatus) {
    IChargeStatus["Failed"] = "FAILED";
    IChargeStatus["Pending"] = "PENDING";
    IChargeStatus["Succeeded"] = "SUCCEEDED";
})(IChargeStatus || (IChargeStatus = {}));
var ICollectionBookmarkStatus;
(function(ICollectionBookmarkStatus) {
    ICollectionBookmarkStatus["Saved"] = "SAVED";
    ICollectionBookmarkStatus["Unsaved"] = "UNSAVED";
})(ICollectionBookmarkStatus || (ICollectionBookmarkStatus = {}));
var ICollectionFeaturedStatus;
(function(ICollectionFeaturedStatus) {
    ICollectionFeaturedStatus["All"] = "ALL";
    ICollectionFeaturedStatus["FeaturedOnly"] = "FEATURED_ONLY";
    ICollectionFeaturedStatus["NotFeatured"] = "NOT_FEATURED";
})(ICollectionFeaturedStatus || (ICollectionFeaturedStatus = {}));
var ICollectionItemType;
(function(ICollectionItemType) {
    ICollectionItemType["Government"] = "GOVERNMENT";
    ICollectionItemType["Group"] = "GROUP";
    ICollectionItemType["Product"] = "PRODUCT";
    ICollectionItemType["Project"] = "PROJECT";
    ICollectionItemType["Story"] = "STORY";
})(ICollectionItemType || (ICollectionItemType = {}));
var ICollectionMethod;
(function(ICollectionMethod) {
    ICollectionMethod["ChargeAutomatically"] = "CHARGE_AUTOMATICALLY";
    ICollectionMethod["SendInvoice"] = "SEND_INVOICE";
})(ICollectionMethod || (ICollectionMethod = {}));
var ICollectionNewContentLastVisitAnchor;
(function(ICollectionNewContentLastVisitAnchor) {
    ICollectionNewContentLastVisitAnchor["LastTrackedViewerVisit"] = "LAST_TRACKED_VIEWER_VISIT";
    ICollectionNewContentLastVisitAnchor["LastVisitArgument"] = "LAST_VISIT_ARGUMENT";
})(ICollectionNewContentLastVisitAnchor || (ICollectionNewContentLastVisitAnchor = {}));
var ICollectionPackaging;
(function(ICollectionPackaging) {
    ICollectionPackaging[/** When a collection have more than two tags. */ "Bundle"] = "BUNDLE";
    ICollectionPackaging[/** When a collection is made of a single tag. */ "Single"] = "SINGLE";
})(ICollectionPackaging || (ICollectionPackaging = {}));
var ICollectionPublishedStatus;
(function(ICollectionPublishedStatus) {
    ICollectionPublishedStatus["Published"] = "PUBLISHED";
    ICollectionPublishedStatus["Unpublished"] = "UNPUBLISHED";
})(ICollectionPublishedStatus || (ICollectionPublishedStatus = {}));
var ICollectionSponsoring;
(function(ICollectionSponsoring) {
    ICollectionSponsoring["None"] = "NONE";
    ICollectionSponsoring["VendorCurated"] = "VENDOR_CURATED";
    ICollectionSponsoring["VendorSponsored"] = "VENDOR_SPONSORED";
})(ICollectionSponsoring || (ICollectionSponsoring = {}));
var ICollectionSponsoringPaymentSchedule;
(function(ICollectionSponsoringPaymentSchedule) {
    ICollectionSponsoringPaymentSchedule["LumpSum"] = "LUMP_SUM";
    ICollectionSponsoringPaymentSchedule["Monthly"] = "MONTHLY";
    ICollectionSponsoringPaymentSchedule["Quarterly"] = "QUARTERLY";
    ICollectionSponsoringPaymentSchedule["Yearly"] = "YEARLY";
})(ICollectionSponsoringPaymentSchedule || (ICollectionSponsoringPaymentSchedule = {}));
var ICollectionSponsoringSponsorshipLevel;
(function(ICollectionSponsoringSponsorshipLevel) {
    ICollectionSponsoringSponsorshipLevel["Product"] = "PRODUCT";
    ICollectionSponsoringSponsorshipLevel["Vendor"] = "VENDOR";
})(ICollectionSponsoringSponsorshipLevel || (ICollectionSponsoringSponsorshipLevel = {}));
var ICollectionSponsoringType;
(function(ICollectionSponsoringType) {
    ICollectionSponsoringType["Curated"] = "CURATED";
    ICollectionSponsoringType["Sponsored"] = "SPONSORED";
})(ICollectionSponsoringType || (ICollectionSponsoringType = {}));
var ICollectionStatus;
(function(ICollectionStatus) {
    ICollectionStatus["Active"] = "ACTIVE";
    ICollectionStatus["Archived"] = "ARCHIVED";
    ICollectionStatus["Inactive"] = "INACTIVE";
})(ICollectionStatus || (ICollectionStatus = {}));
var ICommentRepliesFilter;
(function(ICommentRepliesFilter) {
    ICommentRepliesFilter["All"] = "ALL";
    ICommentRepliesFilter["Viewer"] = "VIEWER";
})(ICommentRepliesFilter || (ICommentRepliesFilter = {}));
var ICommentTargetType;
(function(ICommentTargetType) {
    ICommentTargetType["Post"] = "POST";
    ICommentTargetType["Project"] = "PROJECT";
    ICommentTargetType["Report"] = "REPORT";
    ICommentTargetType["Story"] = "STORY";
})(ICommentTargetType || (ICommentTargetType = {}));
var IConnectTargetType;
(function(IConnectTargetType) {
    IConnectTargetType["Government"] = "GOVERNMENT";
    IConnectTargetType["Group"] = "GROUP";
    IConnectTargetType["User"] = "USER";
    IConnectTargetType["Vendor"] = "VENDOR";
})(IConnectTargetType || (IConnectTargetType = {}));
var IEntityType;
(function(IEntityType) {
    IEntityType["Company"] = "COMPANY";
    IEntityType["Government"] = "GOVERNMENT";
})(IEntityType || (IEntityType = {}));
var IFeaturedTargetType;
(function(IFeaturedTargetType) {
    IFeaturedTargetType["Product"] = "PRODUCT";
    IFeaturedTargetType["Report"] = "REPORT";
    IFeaturedTargetType["Story"] = "STORY";
})(IFeaturedTargetType || (IFeaturedTargetType = {}));
var IFollowType;
(function(IFollowType) {
    IFollowType["Government"] = "GOVERNMENT";
    IFollowType["User"] = "USER";
})(IFollowType || (IFollowType = {}));
var IGovernmentSearchScope;
(function(IGovernmentSearchScope) {
    IGovernmentSearchScope["Innovator"] = "INNOVATOR";
})(IGovernmentSearchScope || (IGovernmentSearchScope = {}));
var IGovernmentVerificationRequestSearchTarget;
(function(IGovernmentVerificationRequestSearchTarget) {
    IGovernmentVerificationRequestSearchTarget["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSearchTarget["Group"] = "GROUP";
    IGovernmentVerificationRequestSearchTarget["Project"] = "PROJECT";
})(IGovernmentVerificationRequestSearchTarget || (IGovernmentVerificationRequestSearchTarget = {}));
var IGovernmentVerificationRequestSortBy;
(function(IGovernmentVerificationRequestSortBy) {
    IGovernmentVerificationRequestSortBy["Created"] = "CREATED";
    IGovernmentVerificationRequestSortBy["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSortBy["Status"] = "STATUS";
})(IGovernmentVerificationRequestSortBy || (IGovernmentVerificationRequestSortBy = {}));
var IGovernmentVerificationRequestSortByDirection;
(function(IGovernmentVerificationRequestSortByDirection) {
    IGovernmentVerificationRequestSortByDirection["Ascending"] = "ASCENDING";
    IGovernmentVerificationRequestSortByDirection["Descending"] = "DESCENDING";
})(IGovernmentVerificationRequestSortByDirection || (IGovernmentVerificationRequestSortByDirection = {}));
var IGovernmentVerificationRequestStatus;
(function(IGovernmentVerificationRequestStatus) {
    IGovernmentVerificationRequestStatus["Cancelled"] = "CANCELLED";
    IGovernmentVerificationRequestStatus["Declined"] = "DECLINED";
    IGovernmentVerificationRequestStatus["Pending"] = "PENDING";
    IGovernmentVerificationRequestStatus["Verified"] = "VERIFIED";
})(IGovernmentVerificationRequestStatus || (IGovernmentVerificationRequestStatus = {}));
var IGovlaunchEnvironment;
(function(IGovlaunchEnvironment) {
    IGovlaunchEnvironment["Production"] = "PRODUCTION";
    IGovlaunchEnvironment["Qa"] = "QA";
})(IGovlaunchEnvironment || (IGovlaunchEnvironment = {}));
var IGroupKind;
(function(IGroupKind) {
    IGroupKind[/** Everything that doesn't fall in the above buckets will be "community" */ "Community"] = "COMMUNITY";
    IGroupKind[/** A group will be considered a Discussion if there's a Collection for it */ "Discussion"] = "DISCUSSION";
    IGroupKind[/** A group will be considered a Vendor if the owner is a Vendor */ "Vendor"] = "VENDOR";
})(IGroupKind || (IGroupKind = {}));
var IGroupRequestStatus;
(function(IGroupRequestStatus) {
    IGroupRequestStatus["Accepted"] = "ACCEPTED";
    IGroupRequestStatus["Canceled"] = "CANCELED";
    IGroupRequestStatus["Declined"] = "DECLINED";
    IGroupRequestStatus["Pending"] = "PENDING";
})(IGroupRequestStatus || (IGroupRequestStatus = {}));
var IGroupVisibility;
(function(IGroupVisibility) {
    IGroupVisibility["Private"] = "PRIVATE";
    IGroupVisibility["Public"] = "PUBLIC";
})(IGroupVisibility || (IGroupVisibility = {}));
var IGroupsFilter;
(function(IGroupsFilter) {
    IGroupsFilter["All"] = "ALL";
    IGroupsFilter["Archived"] = "ARCHIVED";
})(IGroupsFilter || (IGroupsFilter = {}));
var IImageSourceType;
(function(IImageSourceType) {
    IImageSourceType["Product"] = "PRODUCT";
    IImageSourceType["Story"] = "STORY";
})(IImageSourceType || (IImageSourceType = {}));
var IImagesQueryTab;
(function(IImagesQueryTab) {
    IImagesQueryTab["All"] = "ALL";
    IImagesQueryTab["Archived"] = "ARCHIVED";
    IImagesQueryTab["NoAlt"] = "NO_ALT";
    IImagesQueryTab["Placeholder"] = "PLACEHOLDER";
    IImagesQueryTab["WithAlt"] = "WITH_ALT";
})(IImagesQueryTab || (IImagesQueryTab = {}));
var IInvoiceStatus;
(function(IInvoiceStatus) {
    IInvoiceStatus["Draft"] = "DRAFT";
    IInvoiceStatus["Open"] = "OPEN";
    IInvoiceStatus["Paid"] = "PAID";
    IInvoiceStatus["Uncollectible"] = "UNCOLLECTIBLE";
    IInvoiceStatus["Void"] = "VOID";
})(IInvoiceStatus || (IInvoiceStatus = {}));
var ILandingContentType;
(function(ILandingContentType) {
    ILandingContentType["Image"] = "IMAGE";
    ILandingContentType["Podcast"] = "PODCAST";
    ILandingContentType["Video"] = "VIDEO";
})(ILandingContentType || (ILandingContentType = {}));
var IMediaType;
(function(IMediaType) {
    IMediaType["Image"] = "IMAGE";
    IMediaType["Video"] = "VIDEO";
    IMediaType["Youtube"] = "YOUTUBE";
})(IMediaType || (IMediaType = {}));
var INewsletterCampaignFrequency;
(function(INewsletterCampaignFrequency) {
    INewsletterCampaignFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterCampaignFrequency["Monthly"] = "MONTHLY";
    INewsletterCampaignFrequency["Weekly"] = "WEEKLY";
})(INewsletterCampaignFrequency || (INewsletterCampaignFrequency = {}));
var INewsletterFrequency;
(function(INewsletterFrequency) {
    INewsletterFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterFrequency["Monthly"] = "MONTHLY";
    INewsletterFrequency["Weekly"] = "WEEKLY";
})(INewsletterFrequency || (INewsletterFrequency = {}));
var IOutsideProductStatus;
(function(IOutsideProductStatus) {
    IOutsideProductStatus["Added"] = "ADDED";
    IOutsideProductStatus["Denied"] = "DENIED";
    IOutsideProductStatus["Ignored"] = "IGNORED";
    IOutsideProductStatus["Pending"] = "PENDING";
})(IOutsideProductStatus || (IOutsideProductStatus = {}));
var IPlanRecurrency;
(function(IPlanRecurrency) {
    IPlanRecurrency["Monthly"] = "MONTHLY";
    IPlanRecurrency["Yearly"] = "YEARLY";
})(IPlanRecurrency || (IPlanRecurrency = {}));
var IPlanTier;
(function(IPlanTier) {
    IPlanTier["Basic"] = "BASIC";
    IPlanTier["Disruptor"] = "DISRUPTOR";
    IPlanTier["Makers"] = "MAKERS";
    IPlanTier["Makerspro"] = "MAKERSPRO";
})(IPlanTier || (IPlanTier = {}));
var IPostAudience;
(function(IPostAudience) {
    IPostAudience["Community"] = "COMMUNITY";
    IPostAudience["Public"] = "PUBLIC";
})(IPostAudience || (IPostAudience = {}));
var IProcessStatusType;
(function(IProcessStatusType) {
    IProcessStatusType["AdditionalInformationRequired"] = "ADDITIONAL_INFORMATION_REQUIRED";
    IProcessStatusType["PendingVerification"] = "PENDING_VERIFICATION";
    IProcessStatusType["Required"] = "REQUIRED";
    IProcessStatusType["Verified"] = "VERIFIED";
})(IProcessStatusType || (IProcessStatusType = {}));
var IProductFilter;
(function(IProductFilter) {
    IProductFilter["All"] = "ALL";
    IProductFilter["Archived"] = "ARCHIVED";
    IProductFilter["Disruptors"] = "DISRUPTORS";
    IProductFilter["Regular"] = "REGULAR";
    IProductFilter["Submitted"] = "SUBMITTED";
    IProductFilter["Untagged"] = "UNTAGGED";
})(IProductFilter || (IProductFilter = {}));
var IProductSearchScope;
(function(IProductSearchScope) {
    IProductSearchScope["Basic"] = "BASIC";
    IProductSearchScope["Disruptor"] = "DISRUPTOR";
    IProductSearchScope["Makers"] = "MAKERS";
    IProductSearchScope["VendorIsDisruptor"] = "VENDOR_IS_DISRUPTOR";
})(IProductSearchScope || (IProductSearchScope = {}));
var IProductStackRequestStatus;
(function(IProductStackRequestStatus) {
    IProductStackRequestStatus["Accepted"] = "ACCEPTED";
    IProductStackRequestStatus["Canceled"] = "CANCELED";
    IProductStackRequestStatus["Declined"] = "DECLINED";
    IProductStackRequestStatus["Pending"] = "PENDING";
})(IProductStackRequestStatus || (IProductStackRequestStatus = {}));
var IProductStatus;
(function(IProductStatus) {
    IProductStatus["Approved"] = "APPROVED";
    IProductStatus["Submitted"] = "SUBMITTED";
})(IProductStatus || (IProductStatus = {}));
var IProductStatusFilter;
(function(IProductStatusFilter) {
    IProductStatusFilter["All"] = "ALL";
    IProductStatusFilter["Approved"] = "APPROVED";
    IProductStatusFilter["Submitted"] = "SUBMITTED";
})(IProductStatusFilter || (IProductStatusFilter = {}));
var IProfileCoverTarget;
(function(IProfileCoverTarget) {
    IProfileCoverTarget["Company"] = "COMPANY";
    IProfileCoverTarget["Government"] = "GOVERNMENT";
    IProfileCoverTarget["User"] = "USER";
})(IProfileCoverTarget || (IProfileCoverTarget = {}));
var IProjectAudience;
(function(IProjectAudience) {
    IProjectAudience["Community"] = "COMMUNITY";
    IProjectAudience["Private"] = "PRIVATE";
    IProjectAudience["Public"] = "PUBLIC";
})(IProjectAudience || (IProjectAudience = {}));
var IProjectType;
(function(IProjectType) {
    IProjectType["GovernmentProject"] = "GOVERNMENT_PROJECT";
    IProjectType["GroupProject"] = "GROUP_PROJECT";
    IProjectType["VendorProject"] = "VENDOR_PROJECT";
})(IProjectType || (IProjectType = {}));
var ISolutionStatus;
(function(ISolutionStatus) {
    ISolutionStatus["Approved"] = "APPROVED";
    ISolutionStatus["Archived"] = "ARCHIVED";
    ISolutionStatus["Submitted"] = "SUBMITTED";
})(ISolutionStatus || (ISolutionStatus = {}));
var ISortType;
(function(ISortType) {
    ISortType["Newest"] = "NEWEST";
    ISortType["Oldest"] = "OLDEST";
    ISortType["Top"] = "TOP";
})(ISortType || (ISortType = {}));
var IStoryAudience;
(function(IStoryAudience) {
    IStoryAudience["All"] = "ALL";
    IStoryAudience["Community"] = "COMMUNITY";
    IStoryAudience["Public"] = "PUBLIC";
})(IStoryAudience || (IStoryAudience = {}));
var IStoryFilter;
(function(IStoryFilter) {
    IStoryFilter["All"] = "ALL";
    IStoryFilter["Featured"] = "FEATURED";
})(IStoryFilter || (IStoryFilter = {}));
var IStoryStatus;
(function(IStoryStatus) {
    IStoryStatus["Approved"] = "APPROVED";
    IStoryStatus["Proposed"] = "PROPOSED";
    IStoryStatus["Published"] = "PUBLISHED";
    IStoryStatus["Unpublished"] = "UNPUBLISHED";
})(IStoryStatus || (IStoryStatus = {}));
var ISubscriptionStatus;
(function(ISubscriptionStatus) {
    ISubscriptionStatus["Active"] = "ACTIVE";
    ISubscriptionStatus["Cancelled"] = "CANCELLED";
})(ISubscriptionStatus || (ISubscriptionStatus = {}));
var ITagType;
(function(ITagType) {
    ITagType["Award"] = "AWARD";
    ITagType["Custom"] = "CUSTOM";
    ITagType["Department"] = "DEPARTMENT";
    ITagType["Product"] = "PRODUCT";
    ITagType["Project"] = "PROJECT";
    ITagType["Story"] = "STORY";
})(ITagType || (ITagType = {}));
var IUpvoteTargetType;
(function(IUpvoteTargetType) {
    IUpvoteTargetType["Comment"] = "COMMENT";
    IUpvoteTargetType["Post"] = "POST";
    IUpvoteTargetType["Product"] = "PRODUCT";
    IUpvoteTargetType["Project"] = "PROJECT";
    IUpvoteTargetType["Report"] = "REPORT";
    IUpvoteTargetType["Story"] = "STORY";
})(IUpvoteTargetType || (IUpvoteTargetType = {}));
var IUserRole;
(function(IUserRole) {
    IUserRole["Owner"] = "OWNER";
    IUserRole["User"] = "USER";
})(IUserRole || (IUserRole = {}));
var IUserSearchScope;
(function(IUserSearchScope) {
    IUserSearchScope["Citizen"] = "CITIZEN";
    IUserSearchScope["Community"] = "COMMUNITY";
    IUserSearchScope["Disruptor"] = "DISRUPTOR";
    IUserSearchScope["Government"] = "GOVERNMENT";
    IUserSearchScope["Innovator"] = "INNOVATOR";
    IUserSearchScope["Pending"] = "PENDING";
    IUserSearchScope["Vendor"] = "VENDOR";
})(IUserSearchScope || (IUserSearchScope = {}));
var IUserType;
(function(IUserType) {
    IUserType["Disruptor"] = "DISRUPTOR";
    IUserType["Innovator"] = "INNOVATOR";
    IUserType["Regular"] = "REGULAR";
})(IUserType || (IUserType = {}));
var IVendorSearchScope;
(function(IVendorSearchScope) {
    IVendorSearchScope["Disruptor"] = "DISRUPTOR";
})(IVendorSearchScope || (IVendorSearchScope = {}));
var IVerificationInput;
(function(IVerificationInput) {
    IVerificationInput["None"] = "NONE";
    IVerificationInput["Unverified"] = "UNVERIFIED";
    IVerificationInput["Verified"] = "VERIFIED";
})(IVerificationInput || (IVerificationInput = {}));
var IWorkPlaceType;
(function(IWorkPlaceType) {
    IWorkPlaceType["Government"] = "GOVERNMENT";
    IWorkPlaceType["None"] = "NONE";
    IWorkPlaceType["NonprofitOrNgo"] = "NONPROFIT_OR_NGO";
    IWorkPlaceType["Other"] = "OTHER";
    IWorkPlaceType["StateOrFederalAgency"] = "STATE_OR_FEDERAL_AGENCY";
    IWorkPlaceType["Vendor"] = "VENDOR";
})(IWorkPlaceType || (IWorkPlaceType = {}));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductSolutionsCard.tsx





function ProductSolutionsCard(param) {
    var product = param.product;
    var solutions = product.solutions || [];
    if (solutions.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, {
        mt: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardHeader */.Ol, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Service & Product Integrations",
                        id: "wKRmA8"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardBody */.eW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    css: {
                        listStyleType: "none"
                    },
                    children: solutions.filter(function(solution) {
                        return solution.status === ISolutionStatus.Approved;
                    }).map(function(solution) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "sm",
                                as: "span",
                                clamp: 1,
                                children: solution.name
                            })
                        }, solution._id);
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/box/Flex.tsx
var Flex = __webpack_require__(45829);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/theme/ThemeProvider.tsx
var ThemeProvider = __webpack_require__(2424);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/SponsorshipBadges.tsx








var badgeSizes = {
    "2xs": 4,
    xs: 6,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    "2xl": 32,
    full: "full"
};
var Img = web/* Box.withComponent */.xu.withComponent("img");
function SponsorshipBadges(param) {
    var sponsorships = param.sponsorships, _size = param.size, size = _size === void 0 ? "md" : _size;
    var theme = (0,ThemeProvider/* useTheme */.F)();
    var sizeKey = size ? badgeSizes[size] : "md";
    // @ts-ignore
    var _size1 = theme.sizes[sizeKey];
    var badgeSize = parseFloat(_size1) * 2;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: sponsorships.slice(0, 4).map(function(sponsorship, index) {
            if (sponsorship.link) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadgeAnchor, {
                    sponsorship: sponsorship,
                    badgeSize: badgeSize,
                    index: index
                }, "".concat(sponsorship.link, "/").concat(index));
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadge, {
                sponsorship: sponsorship,
                badgeSize: badgeSize,
                index: index
            }, sponsorship.name);
        })
    });
};
function SponsorshipBadgeAnchor(param) {
    var sponsorship = param.sponsorship, badgeSize = param.badgeSize, index = param.index;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: sponsorship.link || "",
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadge, {
            sponsorship: sponsorship,
            badgeSize: badgeSize,
            index: index
        })
    }, sponsorship.name);
}
function SponsorshipBadge(param) {
    var sponsorship = param.sponsorship, badgeSize = param.badgeSize, index = param.index;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "absolute"
    }, getPosition(index, badgeSize)), {
        rounded: "full",
        width: badgeSize,
        height: badgeSize,
        textAlign: "center",
        _hover: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
            label: sponsorship.name,
            "aria-label": sponsorship.name,
            color: "black",
            bg: "gray.100",
            placement: "top",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                rounded: "full",
                size: "100%",
                objectFit: "cover",
                display: "flex",
                children: sponsorship.logo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                    logo: sponsorship.logo
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeName, {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: "white",
                    name: sponsorship.name,
                    rounded: "full",
                    size: "100%",
                    objectFit: "cover",
                    _hover: {
                        backgroundColor: "gray.100",
                        border: "1px",
                        borderColor: "gray.100"
                    }
                })
            })
        })
    }));
}
var Badge = function(param) {
    var logo = param.logo;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        as: "img",
        size: "100%",
        rounded: "full",
        objectFit: "cover",
        src: logo,
        bg: "white",
        _hover: {
            backgroundColor: "gray.100",
            border: "1px",
            borderColor: "gray.100"
        }
    });
};
var getPosition = function(index, size) {
    if (index === 0) {
        return {
            bottom: -size * 2 + 4,
            right: -size * 2 + 4
        };
    }
    if (index === 1) {
        return {
            top: -size * 2 + 4,
            left: -size * 2 + 4
        };
    }
    if (index === 2) {
        return {
            bottom: -size * 2 + 4,
            left: -size * 2 + 4
        };
    }
    return {
        top: -size * 2 + 4,
        right: -size * 2 + 4
    };
};
var BadgeName = function(_param) {
    var name = _param.name, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        textAlign: "center",
        textTransform: "uppercase",
        fontWeight: "medium",
        "aria-label": name
    }, props), {
        children: name ? getInitials(name) : null
    }));
};
var getInitials = function(name) {
    var ref = (0,_sliced_to_array/* default */.Z)(name.split(" "), 2), firstName = ref[0], lastName = ref[1];
    if (firstName && lastName) {
        return "".concat(firstName.charAt(0)).concat(lastName.charAt(0));
    }
    return firstName.charAt(0);
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/components/ProductVendorCard.tsx










function ProductVendorCard(_param) {
    var product = _param.product, renderLinkWrap = _param.renderLinkWrap, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "renderLinkWrap"
    ]);
    if (!product.company) {
        return null;
    }
    var avatar = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
        src: product.company.logo,
        name: product.company.name,
        size: "lg",
        variant: product.company.isDisruptor ? "disruptor-without-icon" : undefined
    });
    var avatarWithBadges = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
            position: "relative",
            children: [
                renderLinkWrap ? renderLinkWrap(product.company, avatar) : avatar,
                product.company.sponsorships && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadges, {
                    sponsorships: product.company.sponsorships,
                    size: "lg"
                })
            ]
        })
    });
    var name = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
        as: "h2",
        size: "md",
        color: "blue.600",
        children: product.company.name
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        bg: "teal.100",
        p: 4,
        textAlign: "center",
        children: [
            avatarWithBadges,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, {
                mt: 4,
                children: [
                    renderLinkWrap ? renderLinkWrap(product.company, name) : name,
                    product.company.yearFounded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        mt: 2,
                        fontSize: "sm",
                        color: "gray.600",
                        fontWeight: "semibold",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Founded in {yearFounded}",
                            id: "RAjY63",
                            values: {
                                yearFounded: product.company.yearFounded
                            }
                        })
                    }),
                    product.company.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        mt: 2,
                        fontSize: "xs",
                        color: "gray.500",
                        fontWeight: "normal",
                        children: product.company.description
                    }),
                    product.company.createdAt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                        mt: 2,
                        fontSize: "sm",
                        color: "gray.600",
                        fontWeight: "normal",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "On Govlaunch since",
                                id: "b05iu8"
                            }),
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IntlDateTime */.Xg, {
                                value: product.company.createdAt
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/fragments/ProductCardFieldsFragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductCardFields on Product {\n    _id\n    slug\n    name\n    logo\n    description\n    isDisruptor\n    tags {\n      _id\n      name\n      slug\n    }\n    inViewerStack\n    governmentsUsingCount\n    allowRequestTranslation\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductCardFieldsFragment = (0,lib/* default */.ZP)(_templateObject());
/* harmony default export */ var fragments_ProductCardFieldsFragment = (ProductCardFieldsFragment);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/fragments/ProductFieldsFragment.ts

function ProductFieldsFragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductFields on Product {\n    _id\n    name\n    logo\n    slug\n    description\n    about\n    link\n    contactPage\n    isDisruptor\n    videos\n    screenshots {\n      url\n      alt\n    }\n    languagesOffered\n    viewerDidBookmark\n    allowRequestTranslation\n    tags {\n      _id\n      name\n      slug\n    }\n    company {\n      _id\n      slug\n      name\n      logo\n      yearFounded\n      description\n      createdAt\n      plan {\n        _id\n        name\n      }\n      viewerIsMember\n      isDisruptor\n      sponsorships {\n        name\n        link\n        logo\n      }\n    }\n    inViewerStack\n    highlights\n    socialMedia {\n      twitter\n      facebook\n      linkedin\n      youtube\n      instagram\n    }\n    alternatives {\n      _id\n      name\n      logo\n      slug\n    }\n    siblings {\n      _id\n      name\n      slug\n      logo\n      isDisruptor\n      inViewerStack\n    }\n    certifications\n    resources {\n      ... on LinkResource {\n        type\n        title\n        url\n        addedAt\n      }\n      ... on DownloadResource {\n        type\n        title\n        url\n        addedAt\n      }\n      ... on TextResource {\n        type\n        title\n        body\n        addedAt\n      }\n    }\n    newsworthy {\n      url\n      title\n      description\n      favicon\n      siteName\n    }\n    integrations {\n      _id\n      name\n      slug\n    }\n    solutions {\n      _id\n      name\n      status\n    }\n    outsideIntegrations {\n      _id\n      name\n      url\n    }\n    releasedYear\n    freeTrial {\n      linkHref\n    }\n    pricingPage\n    deployment {\n      ... on WebProductDeployment {\n        mobileResponsive\n        supportedBrowsers\n      }\n      ... on DesktopProductDeployment {\n        platforms\n      }\n      ... on AppStoreProductDeployment {\n        linkHref\n      }\n      ... on PlayStoreProductDeployment {\n        linkHref\n      }\n    }\n    assistiveTechnologiesCompatibility\n    openSource {\n      ... on ProductOpenSource {\n        linkHref\n      }\n    }\n    enrichedProfile\n    governments {\n      items {\n        _id\n        name\n        slug\n        logo\n        state\n        productsCount\n        budget\n        currency\n        city {\n          _id\n          type\n          state\n          population\n          governmentType\n          country\n          countryName\n        }\n        isInnovator\n      }\n    }\n  }\n"
    ]);
    ProductFieldsFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductFieldsFragment = (0,lib/* default */.ZP)(ProductFieldsFragment_templateObject());
/* harmony default export */ var fragments_ProductFieldsFragment = (ProductFieldsFragment);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/fragments/index.ts



// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/tooltip/Tooltip.tsx + 1 modules
var Tooltip = __webpack_require__(25568);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/src/ProductCard.tsx









var ProductCard = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var product = _param.product, canToggleInStack = _param.canToggleInStack, onToggleInStack = _param.onToggleInStack, translationLinkWrap = _param.translationLinkWrap, props = (0,_object_without_properties/* default */.Z)(_param, [
        "product",
        "canToggleInStack",
        "onToggleInStack",
        "translationLinkWrap"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var onToggleStack = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onToggleInStack === "function" && canToggleInStack) {
            onToggleInStack(product);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        as: "a",
        bg: "white",
        border: "solid 1px",
        borderColor: "gray.100",
        borderRadius: "md",
        cursor: "pointer",
        direction: "column",
        paddingBottom: 8,
        position: "relative",
        transition: "0.2s all",
        _hover: {
            shadow: "lg"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                mb: translationLinkWrap ? 3 : 6,
                children: [
                    translationLinkWrap && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        direction: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 2,
                        children: translationLinkWrap(product.slug)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        position: "absolute",
                        top: 2,
                        right: 2,
                        children: [
                            product.governmentsUsingCount !== null && product.governmentsUsingCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                label: intl.formatMessage({
                                    defaultMessage: "Governments Using",
                                    id: "zSwNnO"
                                }),
                                "aria-label": intl.formatMessage({
                                    defaultMessage: "Governments Using",
                                    id: "zSwNnO"
                                }),
                                color: "blue.50",
                                bg: "blue.600",
                                placement: "top",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    as: "span",
                                    paddingX: 2,
                                    paddingY: 1,
                                    border: "solid 1px",
                                    borderColor: "blue.800",
                                    color: "blue.800",
                                    borderRadius: "md",
                                    fontSize: 10,
                                    children: product.governmentsUsingCount
                                })
                            }),
                            canToggleInStack && !product.inViewerStack && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                label: intl.formatMessage({
                                    defaultMessage: "Add to Stack",
                                    id: "7rcJw5"
                                }),
                                "aria-label": intl.formatMessage({
                                    defaultMessage: "Add to Stack",
                                    id: "7rcJw5"
                                }),
                                bg: "teal.600",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
                                    "aria-label": intl.formatMessage({
                                        defaultMessage: "Add to Stack",
                                        id: "7rcJw5"
                                    }),
                                    icon: AddToStackIcon,
                                    onClick: onToggleStack,
                                    height: "24px",
                                    width: "24px"
                                })
                            }),
                            canToggleInStack && product.inViewerStack && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                label: intl.formatMessage({
                                    defaultMessage: "Click to Remove from Stack",
                                    id: "t9cOZx"
                                }),
                                "aria-label": intl.formatMessage({
                                    defaultMessage: "Click to Remove from Stack",
                                    id: "t9cOZx"
                                }),
                                color: "red.50",
                                bg: "red.600",
                                placement: "top",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
                                    "aria-label": intl.formatMessage({
                                        defaultMessage: "Remove from Stack",
                                        id: "fMgmCu"
                                    }),
                                    icon: AddedToStackIcon,
                                    onClick: onToggleStack,
                                    height: "24px",
                                    width: "24px"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                marginX: 8,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                src: product.logo,
                                name: product.name,
                                size: "lg",
                                variant: product.isDisruptor ? "disruptor" : null
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                overflow: "hidden",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                    fontSize: "xl",
                                    color: "blue.600",
                                    fontWeight: "bold",
                                    mt: 0,
                                    ml: 3,
                                    clamp: 2,
                                    title: product.name,
                                    children: product.name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        fontSize: "sm",
                        mt: 2,
                        mb: 4,
                        clamp: 2,
                        children: product.description
                    }),
                    product.tags && product.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        mt: "auto",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tag */.Vp, {
                                maxWidth: "calc(100% - 24px)",
                                title: product.tags[0].name,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                                    children: product.tags[0].name
                                })
                            }),
                            product.tags.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                as: "span",
                                color: "blue.800",
                                fontSize: "sm",
                                marginLeft: 2,
                                fontWeight: "medium",
                                children: [
                                    "+",
                                    product.tags.length - 1
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
ProductCard.displayName = "ProductCard";
/* harmony default export */ var src_ProductCard = (ProductCard);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+product@2.25.34_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/product/index.ts
















/***/ })

}]);